import { render } from "./FullPageLoader.vue?vue&type=template&id=39222fae&scoped=true"
import script from "./FullPageLoader.vue?vue&type=script&lang=js"
export * from "./FullPageLoader.vue?vue&type=script&lang=js"

import "./FullPageLoader.vue?vue&type=style&index=0&id=39222fae&scoped=true&lang=css"

import exportComponent from "/home/wastedesk_staging/staging.wastedesk.io/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39222fae"]])

export default __exports__